import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${({ theme }) =>
    theme.colors.backgroundLila}; /* CAMBIO: Color lila ROIS */
  padding: ${({ theme }) => theme.spacing.xxl};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.xl};
  }
`;
